import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=4290b5d4&scoped=true&"
import script from "./Header.vue?vue&type=script&setup=true&lang=js&"
export * from "./Header.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=4290b5d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4290b5d4",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QCircularProgress});
